/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of marking activity as seen
 * @export
 * @interface MarkSeenResponse
 */
export interface MarkSeenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MarkSeenResponse
     */
    success: boolean;
    /**
     * Updated cursor position
     * @type {number}
     * @memberof MarkSeenResponse
     */
    lastSeenEventId: number;
    /**
     * Previous cursor position
     * @type {number}
     * @memberof MarkSeenResponse
     */
    previousEventId?: number | null;
}

/**
 * Check if a given object implements the MarkSeenResponse interface.
 */
export function instanceOfMarkSeenResponse(value: object): value is MarkSeenResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('lastSeenEventId' in value) || value['lastSeenEventId'] === undefined) return false;
    return true;
}

export function MarkSeenResponseFromJSON(json: any): MarkSeenResponse {
    return MarkSeenResponseFromJSONTyped(json, false);
}

export function MarkSeenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkSeenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'lastSeenEventId': json['lastSeenEventId'],
        'previousEventId': json['previousEventId'] == null ? undefined : json['previousEventId'],
    };
}

export function MarkSeenResponseToJSON(json: any): MarkSeenResponse {
    return MarkSeenResponseToJSONTyped(json, false);
}

export function MarkSeenResponseToJSONTyped(value?: MarkSeenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'lastSeenEventId': value['lastSeenEventId'],
        'previousEventId': value['previousEventId'],
    };
}

